import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>((theme) => ({
  button: {
    height: "50px",
  },
  form: {
    marginBottom: "1.5rem",
    textAlign: "left",
  },
  greenCheck: {
    height: "20px",
    width: "20px",
    color: "#16871c",
  },
  forgetPasswordButton: {
    marginLeft: "5px",
    cursor: "pointer",
    minWidth: 0,
    height: "auto",
    padding: "0 2px",
    backgroundColor: "transparent",
    border: "none",
    width: "auto",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  textFieldInput: {
    paddingTop: 0,
    paddingBottom: 0,
    marginBottom: 0,
    marginTop: 0,
  },
  textField: {
    paddingTop: 0,
    paddingBottom: 0,
    marginBottom: "4px",
    marginTop: 0,
    boxShadow: "4px 4px 4px 0px #0C38911A",
  },
  forgetPasswordText: {
    color: theme.palette.events.bluePrimary,
  },
  buttonContent: {
    textTransform: "none",
  },
  forgetPasswordContainer: {
    display: "flex",
    position: "relative",
    top: "22px",
    justifyContent: "flex-end",
  },
}));
